export function lowerCase(str: string): string {
  if (str) {
    return str.toLowerCase();
  } else {
    return "";
  }
}
